import { withTranslation } from 'react-i18next';

import { ErrorBoundary as ErrorBoundaryComponent } from './ErrorBoundary';

export const ErrorBoundary = withTranslation()(ErrorBoundaryComponent);
